/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import B_Util       from 'canvas/base/dev/util/B_Util';
import B_Real       from 'canvas/base/dev/child/base/B_Real';
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld';
import B_Sprite     from 'canvas/base/dev/child/sprite/B_Sprite';
import B_Button     from 'canvas/base/dev/child/button/B_Button';
// import S_Define     from 'canvas/select/dev/util/S_Define'

let mix = (superclass) => new MixinBuilder(superclass);

const B_ToolButton = (function(){

    // [V]
    const $ = {

    }

	class B_ToolButton extends mix(B_Real).with(B_ChildWorld, B_Sprite, B_Button) {

		constructor(obj) {
		    super(obj);

			this.rollover(() => {
				this._scaleX = 1.1;
				this._scaleY = 1.1;
			});

			this.rollout(() => {
				this._scaleX = 1;
				this._scaleY = 1;
			});

			this.click(() => {
				// [#] 'FINAL'형 처리
				let solution = this.CODMOS.WORLD._solution;

				if(solution._system == S_Define.SOLUTION_SYSTEM[1]) {
					solution.compareFinal((rtn)=> {
						this.CODMOS.onCanvasEvent(rtn.renew());
					});
				}
			});
		}

		// [V]

		// @DES ::
		getPixelX() { return this._pixelX; }
		setPixelX(x) { this._pixelX = x; }

		// @DES ::
		getPixelY() { return this._pixelY; }
		setPixelY(y) { this._pixelY = y; }

	}

	return B_ToolButton;
}());

export default B_ToolButton;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_ToolButton.js